import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const AllTerrainIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      fill="none"
      viewBox="0 0 245.562 245.562"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M244.062,180.838L150.227,55.725c-1.417-1.889-3.639-3-6-3c-2.361,0-4.584,1.111-6,3l-38.904,51.873L83.876,87.002
	c-1.416-1.889-3.639-3-6-3c-2.361,0-4.583,1.111-6,3L1.5,180.838c-1.704,2.272-1.978,5.314-0.708,7.855
	c1.27,2.54,3.867,4.145,6.708,4.145h230.562c2.841,0,5.438-1.605,6.708-4.145C246.041,186.151,245.767,183.11,244.062,180.838z
	 M22.5,177.838l55.376-73.836l15.446,20.596c1.416,1.889,3.639,3,6,3c2.361,0,4.583-1.111,6-3l38.904-51.873l78.836,105.113H22.5z"
        fill="currentColor"
      />
    </svg>
  );
};

/**
 * @see docs/worklog/TW-873-all-terrain-icon/rfc.md
 * @see docs/worklog/TW-873-all-terrain-icon/tfc.md
 */
